import { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './ScrollablePanel.css';
import elipseImage from '../assets/elipse.png';

gsap.registerPlugin(ScrollTrigger);

const ScrollablePanel = () => {
  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const textRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayIndex, setDisplayIndex] = useState(0);
  const prevIndexRef = useRef(0);

  const rightTexts = [
    { title: 'Trust', text: 'Trust is vital to our partnerships, however trust requires cooperation and investment from both parties. We aim for full transparency in communications - from who we are, to the structures of our deals and commission, we\'re an open book!' },
    { title: 'Adaptability', text: 'Adapting to situations is vital in our industry. We recognise that no two affiliates are the same. Therefore we will adapt to each specific scenario, each affiliate will be able to receive a deal that caters to their needs to create a mutually beneficial arrangement.' },
    { title: 'Dedication', text: 'We are committed to building WinningPartner into a strong and reliable affiliate program. Each affiliate is assigned a dedicated affiliate manager as a single point of contact. Our managers provide ongoing guidance, industry expertise, and personalized support to help partners grow and optimize performance' }
  ];

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    ScrollTrigger.create({
      trigger: section,
      pin: true,
      start: 'top top',
      end: () => `+=${window.innerHeight * rightTexts.length}`,
      onUpdate: (self) => {
        const newIndex = Math.min(
          Math.floor(self.progress * rightTexts.length),
          rightTexts.length - 1
        );
        if (newIndex !== currentIndex) {
          prevIndexRef.current = currentIndex;
          setCurrentIndex(newIndex);
        }
      }
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, [rightTexts.length, currentIndex]);

  useEffect(() => {
    if (imageRef.current) {
      gsap.to(imageRef.current, {
        rotation: currentIndex * 90,
        duration: 0.8,
        ease: 'power2.inOut'
      });
    }

    if (textRef.current && prevIndexRef.current !== currentIndex) {
      const isScrollingDown = currentIndex > prevIndexRef.current;
      const tl = gsap.timeline();
      
      tl.to(textRef.current, {
        y: isScrollingDown ? -200 : 200,
        opacity: 0,
        duration: 0.4,
        ease: 'power2.in',
        onComplete: () => setDisplayIndex(currentIndex)
      })
      .set(textRef.current, {
        y: isScrollingDown ? 200 : -200
      })
      .to(textRef.current, {
        y: 0,
        opacity: 1,
        duration: 0.4,
        ease: 'power2.out'
      });
    }
  }, [currentIndex]);

  return (
    <section ref={sectionRef} className="scrollable-panel-section" id="section-about">
      <div className="scrollable-panel__left">
        <h2>We are a team of iGaming marketing specialists operating under Trusted Gaming, with extensive experience in affiliate marketing.</h2>
        <p>Winning Partner offers a quality platform supported by a portfolio of high-converting casino brands. We recognise the value of our partners, as strong partnerships are the foundation of a successful affiliate program. Through years of industry experience, we have developed a winning formula focused on performance, transparency, and long-term growth.</p>
      </div>
      <img ref={imageRef} src={elipseImage} alt="" className="scrollable-panel__elipse-fixed" />
      <div ref={textRef} className="scrollable-panel__right">
        <h2>{rightTexts[displayIndex].title}</h2>
        <p>{rightTexts[displayIndex].text}</p>
      </div>
    </section>
  );
};

export default ScrollablePanel;
